export const UnorderedList = ({ children }) => {
  const listStyle = {
    marginBlockStart: '0px',
    paddingInlineStart: '0px',
  };

  return <ul style={listStyle}>{children}</ul>;
};
